<template>
  <HomepageWideLayout>
    <ProgressDots step="2" :steps="steps" />
    <b-container class="text-center">
      <h1>Hi {{firstName}}!</h1>
      <h1>Welcome to Brandly</h1>

      <b-form class="form" @submit.prevent="onSubmit">
        <p class="form-intro">Before you place your order, please complete the following:</p>
        <b-form-input
          v-for="{key, label} in personalVars"
          :key="key"
          v-model="info[key]" class="inp" :placeholder="'Your '+label" />

        <div v-if="personalVars.address && teamAddresses !== null" class="addresses">
          <div class="chosen-address" v-if="address">
            <Address :value="address" />
            <b-button variant="link" @click="address_id = null">Change</b-button>
          </div>
          <div class="new-address" v-else-if="adding">
            Enter your address:
            <address>
              <b-form-input v-model="newAddress.line1" class="inp" placeholder="Line1" />
              <b-form-input v-model="newAddress.line2" class="inp" placeholder="Line2" />
              <b-form-input v-model="newAddress.city" class="inp" placeholder="City" />
              <b-form-input v-model="newAddress.state" class="inp" placeholder="State" />
              <b-form-input v-model="newAddress.postcode" class="inp" placeholder="Zip" />
            </address>
            <b-button @click="addAddress" variant="default" size="lg">Done</b-button>
            <div class="error" v-if="addError">{{addError}}</div>
          </div>
          <div class="address-list" v-else>
            Choose your address:
            <Address @click="chooseAddress(addr)" :value="addr" v-for="addr in teamAddresses" :key="JSON.stringify(addr)" />
            <address @click="startAdding">+ New Address</address>
          </div>
        </div>

        <b-button v-if="!adding" type="submit" variant="default" size="lg">
          <WaveSpinner inline color="white" v-if="saving && !skip"/>
          <span v-else-if="requireProductTemplateChoice">Continue</span>
          <span v-else>Start Order</span>
        </b-button>
        <b-button v-if="!adding" type="submit" @click="skip=true" variant="clear" size="lg">
          <WaveSpinner inline color="red" v-if="saving && skip"/>
          <span v-else>Go to dashboard</span>
        </b-button>
      </b-form>

      <!-- debugging tool, turn on debugTools to see it -->
      <pre @click="save"
        style="text-align: left; font-size: small; border: 3px dashed blue;"
        v-if="flags.debugTools"
        v-html="JSON.stringify(personalInfo, null, 4)"></pre>
    </b-container>
  </HomepageWideLayout>
</template>

<style scoped lang="scss">
@import '~scss/colors.scss';

address {
  text-align: left;
  padding: 0.5em;
  font-size: smaller;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  border-radius: 10px;
  cursor: pointer;
  margin: 0;
}
.chosen-address {
  address {
    border: 2px solid $gray-0;
  }
}
.address-list {
  address:hover {
    border-color: $gray-0;
  }
  address {
    margin-top: 0.5em;
  }
}
.addresses {
    margin-bottom: 1em;
}
</style>

<script>
import {mapActions, mapGetters} from 'vuex';
export default {
  data() {
    return {
      skip: false,
      saving: false,
      info: Object.assign({}, this.user ? this.user.personal_info : {}),
      address_id: this.user ? this.user.default_team_address : null,
      adding: false,
      addError: '',
      newAddress: {
        line1: '',
        line2: '',
        city: '',
        state: '',
        postcode: '',
        country: 'US'
      }
    }
  },
  async mounted() {
    this.refreshTeamAddresses();
  },
  watch: {
    user(val) {
      if (!val) return;
      console.log('got user');
      Object.assign(this.info, val.personal_info);
      this.address_id = this.user.default_team_address;
      this.setOrdereeId(this.user.id);
    }
  },
  computed: {
    ...mapGetters(['user', 'requireProductTemplateChoice', 'teamAddresses', 'designId', 'flags', 'personalInfo', 'personalVars', 'personalInfoSettings']),
    firstName() {
      return this.user && this.user.first_name;
    },
    address() {
      if (this.address_id === null) return null;
      return this.teamAddresses.find(addr => addr.id === this.address_id);
    },
    steps() {
      return this.requireProductTemplateChoice
        ? ['Accept invitation', 'Enter details', 'Choose Design', 'Place order']
        : ['Accept invitation', 'Enter details', 'Place order'];
    }
  },
  methods: {
    ...mapActions(['updateProfile', 'refreshTeamAddresses', "startOrderFromProductTemplate", "addTeamAddress", "setOrdereeId"]),
    async startOrder() {
    },
    async onSubmit() {
      this.saving = true;
      if (!this.user) {
        // can't save yet, the personal_info was never loaded
        // hopefully this will resolve itself soon?
        console.log("can't save");
        // Wait a little bit so user can notice it tried
        await new Promise(r => setTimeout(r, 150));
        this.saving = false;
        return;
      }
      await this.updateProfile({
        personal_info: this.info,
        default_team_address: this.address_id
      });
      if (this.requireProductTemplateChoice) {
        this.saving = false;
        this.$router.push('/choosedesign');
      } else {
        if (this.skip) {
          this.$router.push('/dashboard');
        } else {
          await this.setOrdereeId(this.user.id);
          await this.startOrderFromProductTemplate(this.user.team_user_id);
          this.saving = false;
          this.$router.push({name: 'Editor', params: {id: this.designId}});
        }
      }
    },
    async save() {
      await this.updateProfile({personal_info: this.info, default_team_address: this.address_id});
      await this.setOrdereeId(this.user.id);
    },
    async chooseAddress(addr) {
      this.address_id = addr.id;
    },
    startAdding() {
      this.adding = true;
      // Clear new address?
    },
    async addAddress() {
      // save new address
      console.log(this.newAddress);
      try {
        this.address_id = await this.addTeamAddress(this.newAddress);
        // TODO animate?
        this.adding = false;
      } catch(e) {
        if (e.response && e.response.data) e = e.response.data;
        this.addError = e;
        return;
      }
    }
  }
}
</script>


<style scoped lang="scss">
@import '~scss/colors.scss';

.signup-intro {
  max-width: 1060px;
  width: 100%;
  padding: 40px 20px;
  margin: 0 auto;
  display: block;
  @media screen and (max-width: 768px) {
    display: none;
  }
}

h1 {
  margin: 0;
  font-size: 2.5rem;
}

h2 {
  color: $gray-0;
  text-transform: uppercase;
  font-weight: normal !important;
  font-size: 0.8rem;
  letter-spacing: 0.1rem;
}

.form {
  margin: 2em auto;
  max-width: 300px;
  > p {
    margin-bottom: 1.5em;
  }
  > .inp {
    margin-bottom: 0.5em;
  }
  .have-design {
    margin: 1em 0;
    label { margin: 0;}
  }

  .placeholder {
    color: $gray-0;
  }

  button {
    width: 100%;
    &.primary {
      background-color: red;
      border-color: red;
    }
  }

  .skip-link {
    display: block;
    margin: 0.8em;
    color: $gray-0;
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.1rem;
  }
}
@import url("https://fonts.googleapis.com/css?family=Roboto");
@import "~scss/social.scss";

</style>



// WEBPACK FOOTER //
// src/components/pages/homepage/Setup.vue